import React, { type ReactElement } from 'react';
import clsx from 'clsx';

type Props = {
  className?: string;
  children?: React.ReactNode;
};

function Table({ className, children }: Props): ReactElement {
  return <table className={clsx('table table-sm', className)}>{children}</table>;
}

function Head({ className, children }: Props): ReactElement {
  return <thead className={clsx('table-dark table-bordered', className)}>{children}</thead>;
}

type HeaderProps = Props & {
  size?: number;
};

function Header({ className, size, children }: HeaderProps): ReactElement {
  return (
    <th className={className} {...(size ? { style: { width: `${size}px` } } : {})}>
      {children}
    </th>
  );
}

function Row({ className, children }: Props): ReactElement {
  return <tr className={clsx('align-middle', className)}>{children}</tr>;
}

function Body({ className, children }: Props): ReactElement {
  return <tbody className={className}>{children}</tbody>;
}

type DataCellProps = Props & {
  colSpan?: number;
};

function DataCell({ className, colSpan, children }: DataCellProps): ReactElement {
  return (
    <td className={className} {...(colSpan ? { colSpan } : {})}>
      {children}
    </td>
  );
}

export default Object.assign(Table, {
  Head,
  Header,
  Row,
  Body,
  DataCell
});
